import Vue from "vue";
import { CONTANTS } from "~/constants";

// Make sure to pick a unique name to prevent memory leaks
if (!Vue.__builder_mixin__) {
  Vue.__builder_mixin__ = true;

  Vue.config.optionMergeStrategies.fetch = function (parentVal, childVal, vm) {
    if (!childVal) {
      return parentVal;
    }
    if (!parentVal) {
      return childVal;
    }

    return async function () {
      await parentVal.call(this);
      await childVal.call(this);
    };
  };

  Vue.mixin({
    props: {
      fetchSSR: {
        type: Boolean,
        default: undefined,
      },
    },
    data() {
      return {
        tick: +new Date(),
      };
    },
    // hid is used as unique identifier. Do not use `vmid` for it as it will not work
    // Info: To avoid duplicated meta tags when used in child component, set up an unique identifier with the hid key for your meta elements (read more).
    head() {
      return {
        // title: 'Canhanf.com - Tài chính cá nhân',
        meta: [
          // { hid: 'charset', charset: 'utf-8' },
          {
            hid: "viewport",
            name: "viewport",
            content:
              "width=device-width, initial-scale=1.0",
          },
          { hid: "referrer", name: "referrer", content: "no-referrer" },
          { hid: "google", name: "google", content: "notranslate" },
          {
            hid: "keywords",
            name: "keywords",
            content:
              "Canhanf is the essential software designed for cafes and small retail businesses to optimize checkout, manage inventory, and boost revenue effortlessly",
          },
          {
            hid: "author",
            name: "author",
            content: "cafetaichinh247@gmail.com",
          },
          {
            hid: "fb:app_id",
            property: "fb:app_id",
            content: CONTANTS.FB_APP_ID,
          },
          {
            hid: "fb:admins",
            property: "fb:admins",
            content: CONTANTS.FB_PAGE_ID,
          },
          {
            hid: "fb:pages",
            property: "fb:pages",
            content: CONTANTS.FB_PAGE_ID,
          },
          {
            hid: "facebook-domain-verification",
            name: "facebook-domain-verification",
            content: CONTANTS.FB_SITE_VERIFY,
          },
          { hid: "type", name: "type", content: "website" },
          { hid: "theme-color", name: "theme-color", content: "#4db2ec" },
          {
            hid: "mobile-web-app-capable",
            name: "mobile-web-app-capable",
            content: "yes",
          },
          {
            hid: "apple-mobile-web-app-status-bar-style",
            name: "apple-mobile-web-app-status-bar-style",
            content: "black",
          },
          { hid: "robots", name: "robots", content: "index,follow" },
          { hid: "og:type", property: "og:type", content: "website" },
          {
            hid: "og:site_name",
            property: "og:site_name",
            content: "canhanf.com",
          },
          { hid: "og:image:width", property: "og:image:width", content: "400" },
          {
            hid: "og:image:height",
            property: "og:image:height",
            content: "300",
          },
          { hid: "og:locale", property: "og:locale", content: "en_US" },
          {
            hid: "og:locale:alternate",
            property: "og:locale:alternate",
            content: "en_US",
          },
          // { hid: 'og:url', property: 'og:url', content: `http://${this.$config?.baseHost}${this.$nuxt?.context?.route?.fullPath}` },
          {
            hid: "twitter:card",
            property: "twitter:card",
            content: "summary_large_image",
          },
          {
            hid: "twitter:site",
            property: "twitter:site",
            content: "@nguyen_bing",
          },
          {
            hid: "twitter:creator",
            property: "twitter:creator",
            content: "@nguyen_bing",
          },
          {
            hid: "og:updated_time",
            property: "og:updated_time",
            content: new Date().valueOf(),
          },
          {
            hid: "google-site-verification",
            name: "google-site-verification",
            content: CONTANTS.GOOGLE_SITE_VERIFY,
          },
          {
            hid: "google-signin-scope",
            name: "google-signin-scope",
            content: "profile email",
          },
          {
            hid: "google-signin-client_id",
            name: "google-signin-client_id",
            content: CONTANTS.GG_CLIENT_ID,
          },
          {
            hid: "msvalidate.01",
            name: "msvalidate.01",
            content: CONTANTS.BING_SITE_VERIFY,
          },
        ],
      };
    },

    fetchOnServer() {
      return this.fetchSSR == null ? true : this.fetchSSR;
    },
    computed: {
      $$google() {
        return window.google;
      },

      $$users() {
        return this.$store.state.auth;
      },

      $$customer() {
        return this.$get(this.$$users, "user", "");
      },

      $$siteMeta() {
        // return this.$t("meta.site");
        return this.$t("meta.site_short");
      },

      $$siteShortMeta() {
        return this.$t("meta.site_short");
      },

      $$authorized() {
        return (
          this.$store.state.temp.values.password !== "-" &&
          (this.$store.state.temp.values.password ||
            this.$store.getters["admin/isSigned"] == "1")
        );
      },

      $$permissions() {
        return this.$get(this.$$customer, "user_permissions", []);
      },

      $$subscriptions() {
        if (!this.$$customer) return null;

        const userSubscriptions = this.$get(
          this.$$customer,
          "subscription",
          {}
        );

        return userSubscriptions || {};
      },

      $$isAdmin() {
        return this.$$permissions.includes(
          "stock.stock.view_stockconfiguration.admin"
        );
      },

      $$isShop() {
        return this.$$permissions.includes(
          "stock.stock.view_stockconfiguration.isshop"
        );
      },

      $$FB() {
        return window.FB;
      },

      $$configs() {
        return this.$store.getters["config/getConfigs"];
      },

      $$configSettings() {
        return this.$get(this.$$configs, "[0]", null);
      },

      $$configSettingPassword() {
        return this.$get(this.$$configs, "[0].password", "");
      },

      $$display() {
        // 1. Not signed in
        if (!this.$$customer) return false;

        // 2. Not config, should go to config first time, just access the config page
        // if (!this.$$configSettings && this.$route.path.includes("mem/config"))
        //   return true;

        if (this.$$configSettings === null) return true;

        if (this.$$configSettingPassword.length <= 0) return true;

        return this.$$authorized;
      },
    },
    mounted() {
      this.$nuxt.$on("refresh", this._selfUpdate);

      if (this.onQueryChanged) {
        this._currentRoutePath = this.$route.path;

        this._unwatchQuery = this.$watch(
          "$route.query",
          this._onReadyQueryChanged
        );
      }
      if (this.onRouteChanged) {
        this.$nuxt.$on("ice:routeChanged", this.onRouteChanged);
      }
      this.$on("emitUp", this.$receiveEmit);
    },
    beforeDestroy() {
      if (!this.$nuxt) {
        return;
      }
      this.$nuxt.$off("refresh", this._selfUpdate);
      if (this.onQueryChanged && this._unwatchQuery) {
        this._unwatchQuery();
        this._unwatchQuery = null;
      }
      if (this.onRouteChanged) {
        this.$nuxt.$off("ice:routeChanged", this.onRouteChanged);
      }
    },
    activated() {
      this.$nuxt.$on("refresh", this._selfUpdate);

      if (this.onQueryChanged && !this._unwatchQuery) {
        this._currentRoutePath = this.$route.path;

        this._unwatchQuery = this.$watch(
          "$route.query",
          this._onReadyQueryChanged
        );
      }
    },
    deactivated() {
      this.$nuxt.$off("refresh", this._selfUpdate);

      if (this.onQueryChanged && this._unwatchQuery) {
        this._unwatchQuery();
        this._unwatchQuery = null;
      }
    },
    methods: {
      $emitUp(data) {
        this.$emit("emitUp", data);
      },
      $receiveEmit(e) {
        if (this.$listenEmit) {
          if (this.$listenEmit(e) === false) {
            return;
          }
        }

        this.$parent && this.$parent.$emitUp(e);
      },

      _onReadyQueryChanged(newValue, oldValue) {
        this.$wait(70).then(() => {
          if (this.$route.path == this._currentRoutePath) {
            this.onQueryChanged();
          }
        });
      },
      _updateTick() {
        this.tick = +new Date();
      },
      _selfUpdate() {
        if (this.$fetch) {
          this.$fetch();
        }
        this.tick = +new Date();
      },
    },
  });
}
